import classnames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function CommunicationError({ className, message, onClick, helpDocHref }) {
  const { t } = useTranslation();
  if (helpDocHref) {
    const helpDocDetail = ` ${t('For more information, please visit our')} `;
    return (
      <span className={classnames('communicationError', className)} onClick={onClick}>
        <span className="communicationError-message">
          {message}
          {helpDocDetail}
          <a className="communicationError-helpDoc-link" href={helpDocHref} rel="noreferrer" target="_blank">
            {t('help docs')}
          </a>
        </span>
      </span>
    );
  }

  return (
    <span className={classnames('communicationError', className)} onClick={onClick}>
      <span className="communicationError-message">{message}</span>
    </span>
  );
}
